import styled from 'styled-components';

export const Header = styled.header`
  @media screen and (max-width: 767px) {
    .additional-services-header-description {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;
